import { render, staticRenderFns } from "./projectSelect.vue?vue&type=template&id=0616bddd&scoped=true&"
import script from "./projectSelect.vue?vue&type=script&lang=js&"
export * from "./projectSelect.vue?vue&type=script&lang=js&"
import style0 from "./projectSelect.vue?vue&type=style&index=0&id=0616bddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616bddd",
  null
  
)

export default component.exports